import maps from './maps'

var autocompleteService
var placesService

function getAutocompleteService() {
    if (autocompleteService) return autocompleteService
    return autocompleteService = new maps.places.AutocompleteService()
}

function getPlacesService() {
    if (placesService) return placesService

    var element = document.createElement('div')
    document.body.appendChild(element)
    return placesService = new maps.places.PlacesService(element)
}

export function autocompleteMatcher(q, cb) {
    if (q) {
        const options = {
            input: q,
            componentRestrictions: {
                country: 'fr'
            },
            types: ['geocode']
        }

        getAutocompleteService().getPlacePredictions(options, (predictions) => {
            cb(predictions || [])
        })
    } else {
        cb([])
    }
}

export function provideAutocompleteMatcher(predictionOptions) {
    const {input, ...otherPredictionOption} = predictionOptions
    const inputPrefix = input && (input + ' ') || ''

    return (q, cb) => {
        if (q) {
            const options = {
                input: inputPrefix + q,
                componentRestrictions: {
                    country: 'fr'
                },
                types: ['geocode'],
                ...otherPredictionOption
            }

            getAutocompleteService().getPlacePredictions(options, (predictions) => {
                cb(predictions || [])
            })
        } else {
            cb([])
        }
    }
}

export function addressField(field) {

    function onChange(prediction) {
        getPredictionAddress(prediction, field.onChange)
    }

    return {...field, onChange}
}

export function getPredictionAddress(prediction, cb) {

    function populateAddress(address, addressComponent) {
        addressComponent.types.forEach((type) => {
            switch(type) {
                case 'street_number': 
                    address.number = addressComponent['long_name']
                    break
                case 'route':
                    address.street = addressComponent['long_name']
                    break
                case 'locality':
                    address.city = addressComponent['long_name']
                    break
                case 'country':
                    address.country = addressComponent['long_name']
                    break
                case 'postal_code':
                    address.zipCode = addressComponent['long_name']
                    break
            }
        })
        return address
    }

    getPlacesService().getDetails({placeId: prediction.place_id}, (place) => {
        if (place) {
            var address = {
                number: null,
                street: null,
                city: null,
                country: null,
                zipCode: null,
                checker: {
                    googlePlaceId: place['place_id']
                },
                geoLocation: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                }
            }

            address = place['address_components'].reduce(populateAddress, address)
            cb(address)
        } else {
            cb(null)
        }
    })
}

export function highlightPrediction(prediction) {
    const chars = prediction.description
    const matches = prediction['matched_substrings']
    var index = -1
    var offset = -1
    var limit = -1
    next()

    function next() {
        index++
        if (index < matches.length) {
            offset = matches[index].offset
            limit = offset + matches[index].length - 1
        }
    }

    const highlight = [...chars].map((char, index) => {
        var result = char

        if (index == offset) {
            result = '<b>' + result
        }

        if (index == limit) {
            result = result + '</b>'
            next()
        }

        return result
    }).join('')

    return {__html: highlight}
}

export function displayPrediction(prediction) {
    return prediction.description
}


// WEBPACK FOOTER //
// ./lib/core/google/places.js